var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{directives:[{name:"tip",rawName:"v-tip",value:(_vm.label),expression:"label"}],staticClass:"group-tag",style:(_vm.style)},[_vm._v(_vm._s(_vm.label))])
}
var staticRenderFns = []

export { render, staticRenderFns }